import React from 'react'

const Clothing = () => {
  return (
    <div>
      goods
    </div>
  )
}

export default Clothing

